<template>
  <div class="cell-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <dataGridCellSize :options="options.options" :ids="ids" />
      <el-collapse-item v-if="autoLayoutType !== 'free'" title="排列" name="2">
        <div v-if="showRowColLayout" class="content">
          <rowColLayoutSetting :options="options.options" :ids="ids" @update="handleSet"/>
        </div>
      </el-collapse-item>
      <el-collapse-item title="背景" name="3">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
      </el-collapse-item>
      <el-collapse-item title="边框" name="4">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
          </div>
          <cx-border
            v-if="showBorder"
            :borderWidth.sync="borderWidth"
            :borderStyle.sync="borderStyle"
            :borderColor.sync="borderColor"
            :borderIsThemeColor.sync="borderIsThemeColor"
          />
        </div>
        <div class="content-item mt12">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边距" name="5">
        <div class="setting-item">
          <div class="content">
            <div class="content-item">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="6">
        <div class="setting-item">
          <div class="content">
            <slider-and-input
              class=""
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <div class="content-item mt8">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item verticallyCenter mt16">
              <span class="mr16">溢出</span>
              <text-setting-overflow :overFlowType.sync="overFlowType" style="flex: 1"></text-setting-overflow>
            </div>
            <div class="content-item verticallyBetweenCenter mt12">
              <span class="verticallyCenter">布局模式<i class="tips-btn icon-portal-info2" @click="explainAutoDialog = true"></i></span>
              <el-select v-model="autoLayoutType" style="width: 120px;">
                <el-option v-for="(item, index) in layoutTypeList" :key="index" :label="item.label" :value="item.value">
                  <span style="font-size: 13px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="layoutComponent"
      :options="options"
      type="Setting"
      :rect_id="rect_id"
      :container_id="container_id"
    />
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        {{ explainTips }}<span>{{ explainTitle }}</span>
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainAutoDialog" custom-class="explainDialog">
      <div class="auto-layout-body">
      <p class="fs14 tips">
        <span>排列模式：</span>
      </p>
      <ul>
        <li>开启排列模式后，布局内部元素会按照一定方向排列，配合行布局组件可以实现均匀的排列效果</li>
      </ul>
      <p class="fs14 tips">
        <span>功能说明：</span>
      </p>
      <p>
        通常情况下，一个网页的元素是遵从一定的顺序进行排列，例如2张图片横向排列，第3张以及后续图片都希望自动往左侧填充，超过宽度则自动换行，不仅可以减少整理页面的时间还可以实现更灵活的自适应效果。可以理解「自动布局」是为了简化原生页面使用Flex属性，并且达到类似的效果，你可以做到：
      </p>
      <ul>
        <li>让按钮或卡片随文本增减而自动调整尺寸</li>
        <li>将列表快速重新排序</li>
        <li>实现更多更复杂元素的全自动排布</li>
      </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dataGridCellSize from "./dataGridCellSize.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import emptyLayoutComponent from "emptyLayoutComponent/emptyLayoutComponent.vue"
import { withMethodsHistoryCombine } from "utils/revork"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import rowColLayoutSetting from "../../../materials/autoLayout/toolbars/setting/rowColLayoutSetting.vue"
export default withMethodsHistoryCombine({
  components: {
    dataGridCellSize,
    widthAndSizeAndZindex,
    elementPluginSetting,
    emptyLayoutComponent,
    TextSettingOverflow,
    rowColLayoutSetting
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      shapeChecked: true,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../assets/images/dotted-1.png")
        }
      ],
      top_status: true,
      contextPath: "",
      before: null,
      explainDialog: false,
      explainAutoDialog: false,
      explainTips: "",
      explainTitle: "",
      explainImgSrc: require("../../../assets/images/tipsVideoImg/cropping-img.png"),
      explainVideoSrc: "",
      translate: 0,
      layoutTypeList: [
        {
          label: "自由拖拽",
          value: "free"
        },{
          label: "纵向排列",
          value: "vertical"
        },{
          label: "横向排列",
          value: "horizon"
        },
      ]
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    width: {
      get() {
        return this.options.options.width
      },
    },
    height: {
      get() {
        return this.options.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "height", false)
      }
    },
    opacity: {
      get() {
        return this.options.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.options.borderTopLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.options.borderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.options.borderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.options.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.options.borderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.options.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.options.borderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options ? this.options.options.borderColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.options.showBorder === undefined) {
          if (this.options.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.options.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderShadowChecked: {
      get() {
        return this.boxShadowColor !== "rgba(0, 0, 0,0.5)"
      },
      set(val) {
        if (val) {
          this.boxShadowColor = "#ffffff"
        } else {
          this.boxShadowColor = "rgba(0, 0, 0,0.5)"
        }
      }
    },
    boxShadowColor: {
      get() {
        return this.options ? this.options.options.boxShadowColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    background: {
      get() {
        let background = this.options.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          if (background.length === 1 && background[0].type === "color" && !background[0].color) {
            background[0].color = "rgba(255,255,255,0)"
          }
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.options.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    paddingTypeFlag: {
      get() {
        return this.options.options.paddingTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    overFlowType: {
      get() {
        return this.options.options.hasOwnProperty("overFlowType") ? this.options.options.overFlowType : "auto"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "overFlowType", false)
      }
    },
    showRowColLayout: {
      get() {
        return this.options.options.hasOwnProperty("showRowColLayout") ? this.options.options.showRowColLayout : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRowColLayout", false)
      }
    },
    rowColMargin: {
      get() {
        return this.options?.rowColMargin || 0
      },
      set(newVal) {
        if (!this.options.options.rowColDirection) {
          this.$changeOptionsEV("vertical", "rowColDirection", false)
        }
        this.$changeOptionsEV(newVal, "rowColMargin", false)
      }
    },
    rowColAlignPositionH: {
      get() {
        return this.options.options.hasOwnProperty("rowColAlignPositionH") ? this.options.options.rowColAlignPositionH : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rowColAlignPositionH", false)
      }
    },
    rowColAlignPositionV: {
      get() {
        return this.options.options.hasOwnProperty("rowColAlignPositionV") ? this.options.options.rowColAlignPositionV : "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rowColAlignPositionV", false)
      }
    },
    autoLayoutType: {
      get() {
        if (this.showRowColLayout && this.options.options) {
          return this.options.options.rowColDirection || "vertical"
        } else {
          return "free"
        }
      },
      set(newVal) {
        if (newVal === "free") {
          this.showRowColLayout = false
          if (this.height === "auto") {
            // 如果高度为自适应，取消自动布局应该把高度设置为px
            this.height = 200
            this.handleSet("heightType", "px")
          }
        }
        else {
          this.showRowColLayout = true
          this.handleSet("rowColDirection", newVal)
        }
      }
    },
  },
  methods: {
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTitle = ""
          this.explainTips = "通过调整行数或列数，来对数据排列和数量进行调整"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/pailie-video.mp4")
          break
        case 2:
          this.explainTitle = "仅在预览页生效"
          this.explainTips = "勾选裁剪内容后，任何溢出容器的内容都将被隐藏，不会显示在容器的边界之外。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/cropping-img.png")
          this.explainVideoSrc = ""
          break
        case 3:
          this.explainTitle = ""
          this.explainTips =
            "开启滚动后，可以选择横向滚动或者竖向滚动，滚动内容宽度必须大于滚动区宽度，才能实现滚动效果。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/open-scroll.png")
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    handleSet(key, val) {
      this.$changeOptionsEV(val, key, false)
    }
  }
})
</script>

<style scoped lang="scss">
.signal_tb {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_tb .item1 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_tb .item2 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_bt .item1 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt .item2 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_lr .item1 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr .item2 {
  width: calc(100% - 24px);
  height: 62px;
  float: left;
  background: rgba(61, 130, 242, 0.1);
}
.signal_rl {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_rl .item1 {
  width: calc(100% - 24px);
  height: 62px;
  background: rgba(61, 130, 242, 0.1);
  float: left;
}
.signal_rl .item2 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.keep-all {
  word-break: keep-all;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--themeColor);
  padding: 8px 68px;
}
.childPageSettingBtn:hover {
  cursor: pointer;
}
.mr32 {
  margin-right: 32px;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  margin-left: 16px;
  .num-btn {
    display: inline-block;
    width: 38px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
    }
  }
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 0;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.third-text {
  color: var(--thirdTextColor);
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn.height32 span {
  height: 26px;
  line-height: 26px;
  font-size: 13px;
}
</style>
